import extracurricularsData from './extracurriculars-content.json';
import type { ExtracurricularsGuideContent } from './types';

export * from './types';

export const extracurricularsContent = extracurricularsData as ExtracurricularsGuideContent;
